function addBodyClass() {
  const bodyClass = document.body.classList;

  if (!bodyClass.contains('single-post') && !bodyClass.contains('single-media-library')) {
    return;
  }

  const articleEl = document.querySelector('main article.type-post');
  if (!articleEl) return;
  const targetGroup = articleEl.getAttribute('data-target-group');
  if (targetGroup) {
    document.body.classList.add(targetGroup);
  }
}
